import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-admin/ai-agent-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_COMPANY_APPROVAL'],
    menu: {
      labelI18nKey: 'admin.company.aiAgentManagement.title.aiAgentManagement'
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.aiAgentManagement.menu.list'
      }
    },
    {
      path: `${basePath}/edit/:id`,
      component: Editor,
      meta: {
        isEditor: true,
        isNewPage: true,
        titleI18nKey: 'admin.company.aiAgentManagement.menu.edit'
      }
    }
  ]
}
